module.exports = __webpack_public_path__ + "static/media/B48869-RECEIV_1.ca7479d6.PDF";